<template>
<div>
    <b-breadcrumb>
        <b-breadcrumb-item>{{$t('sidebar.reporte-clases')}}</b-breadcrumb-item>
        <b-breadcrumb-item active>{{$store.state.user.strFullName}}: Student Reports</b-breadcrumb-item>
    </b-breadcrumb>
    <div class="card">
        <div class="card-body">
            <div class="d-flex align-items-center justify-content-between" style="margin-bottom: 24px;" v-if="true">
            <div class="filters">

                    <b-form-group :label="$t('evaluations-reports.index.author')" class="ml-2 mr-3" style="width: 200px;">
                        <CustomSelect
                            @input="idValueSelectAuthor"
                            :options="arrayoptionAuthor"
                            value="id"
                            label="descripcion"
                            :default="$t('filter.text')"
                            @change="changeFilter()"
                        />
                    </b-form-group>

                    <b-form-group :label="$t('evaluations-reports.index.courses')" class="ml-2 mr-3" style="width: 320px;">
                        <v-select
                            multiple
                            :close-on-select="false"
                            :options="arrayoptionSubject"
                            v-model="selectSubject"
                            label="descripcion"
                            :reduce="option => option.id"
                            :placeholder="$t('historial.cursos.filter.1.placeholder')"
                            :deselect-from-dropdown="true"
                            @input="changeFilter()"
                            class="courses-vselect"
                        >
                            <template #selected-option>
                                {{ coursesLabel }}
                            </template>
                            <template #option="option">
                                <span class="material-icons"
                                      style="font-size:16px; vertical-align:middle; margin-right:8px; color:#2c6bed;"
                                      v-if="selectSubject.includes(option.id)">check</span>
                                <span v-else style="display:inline-block; width:24px; margin-right:8px;"></span>
                                {{ option.descripcion }}
                            </template>
                            <template #no-options>{{ $t('reusables.list-is-empty') }}</template>
                        </v-select>
                    </b-form-group>

                    <b-form-group class=" selectYear ml-2" style="margin-top:29px;">
                        <b-form-select class="w-100"
                        value-field="id" text-field="descripcion"
                            v-model="selectedYear"
                            :options="arrayoptionYear"
                            @change="changeFilter"
                            >
                            <b-form-select-option :value="0" >{{$t('reusables.every-year')}}</b-form-select-option>
                        </b-form-select>
                    </b-form-group>

                </div>
            </div>
            <b-table
                responsive
                hover
                :busy="isBusy"
                :show-empty="true"
                id="table-report"
                :tbody-transition-props="transProps"
                primary-key="date"
                style="white-space: pre-line;"
                :items="itemsStudentReports"
                :fields="fieldStudentReports"
                :empty-text="$t('reusables.empty-text')"
            >
                <template #table-busy>
                        <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong> {{$t('ClassRequest.Loading')}}...</strong>
                        </div>
                </template>
                <template #cell(courses)="data">
                    <div>
                        <p v-for="(item, index) in data.value" :key="index">{{item}}</p>
                    </div>
                </template>
                <template #cell(report)="data">
                    <div v-if="data != null && data.item.id > 0">
                        <a class="link" @click="goViewReport(data.item)"><span class="blue">{{$t('reusables.view-report')}}</span></a>
                    </div>
                </template>
                <template #cell(author)="data">
                    <p>{{data.item.id > 0 ? data.value : '-'}}</p>
                </template>
            </b-table>
          <div class="overflow-auto content-pagination">
            <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            aria-controls="table-report"
            ></b-pagination>
            {{currentPage}}-{{perPage}} / {{totalRows}}  {{$t('ClassRequest.text.3')}}
        </div>
        </div>
    </div>
</div>
</template>
<script>
import { baseInstanceAxios } from '@/assets/js/axiosBase.js';
import CustomSelect from "@/components/form/select";
import { TYPESTATEREPORTSTUDENT } from '@/assets/js/appConstants';

export default {
    components:{
        CustomSelect,
    },
    data(){
        return{
            lang:localStorage.getItem('lang') || 'es',
            isBusy: false,
            arrayoptionSubject: [],
            selectSubject: [],
            optionsReport:[],
            selectedYear:0,
            arrayoptionYear : [],
            arrayoptionAuthor : [],
            selectAuthor:0,
            totalRows :0,
            perPage: 10,
            currentPage: 1,
            transProps: {
                name: 'flip-list'
            },
            fieldStudentReports:[
            {key:'date' , label:this.$t('evaluations-reports.index.table-th.1')},
            {key:'courses' , label:this.$t('evaluations-reports.index.table-th.2')},
            {key:'report' , label:this.$t('evaluations-reports.index.table-th.3')},
            {key:'author' , label:this.$t('evaluations-reports.index.table-th.4')}
            ],
            itemsStudentReports: [],
        }
    },
    computed: {
        coursesLabel() {
            if (!this.selectSubject || this.selectSubject.length === 0) {
                return this.$t('historial.cursos.filter.1.placeholder');
            }
            return `${this.selectSubject.length} course${this.selectSubject.length > 1 ? 's' : ''} selected`;
        }
    },
    created(){
        this.getListFilters();
        this.getListReports();
    },
    watch:{
        currentPage: {
			handler: function(newVal, oldVal) {
				this.getListReports();
			}
		},
    },
    methods:{
        idValueSelectAuthor(event){
           this.selectAuthor = event;
        },
        backStep(){
            this.$router.go(-1)
        },
        goViewReport(item){
            let data = {
                teacher : item.author,
                id : item.id,
                flagSearch:item.flagSearch,
                nameCourses: item.courses,
                personsStudentId:this.$store.state.user.personStudentId,
                personTeacherId: item.personTeacherId,
                groupPlanId: item.groupPlanId,
                listGroupRegisterSubjectIds:item.coursesId,
                year:  item.year,
                month: item.month,
                flagTeacherReport : item.flagTeacherReport,
                showDownload : item.report
            }
            this.$router.push({
                name : 'student/evaluations-reports/view-report',
                params : data
            })
        },
        changeFilter(){
            this.currentPage = 1;
            this.getListReports();
        },
        getListFilters(){
            let params = {
                personStudentId : this.$store.state.user.personStudentId,
                flagState : true,
                personTeacherIdSearch : null
            };

            baseInstanceAxios
                .get(`${this.apiURL}/resources/PersonsStudentsReports/ListSubjectsLevelHistoryByPersonStudent`, {params})
                .then(response => {
                    if(response.data.entity){
                        this.arrayoptionYear = response.data.entity.year;
                        this.arrayoptionAuthor = response.data.entity.authors;
                        this.arrayoptionSubject = response.data.entity.listSubjects;
                    }
                });
        },
        getListReports(){
            this.isBusy = true;

            let body = {
                PersonsStudentId : this.$store.state.user.personStudentId,
                ListSubjectLevelsIds: this.selectSubject.length > 0 ? this.selectSubject : null,
                FlagStatus: TYPESTATEREPORTSTUDENT.VIEWREPORT,
                Year: this.selectedYear,
                PersonTeacherId: this.selectAuthor ? this.selectAuthor : 0,
                Page: this.currentPage,
                Size: this.perPage
            };
            baseInstanceAxios
            .post(`${this.apiURL}/resources/PersonsStudentsReports/ListPersonsStudentsByReports`, body)
            .then(response => {
                this.itemsStudentReports = response.data.list.map(element => ({
                    id : element.id,
                    personTeacherId : element.personTeacherId,
                    personsStudentId : element.personsStudentId,
                    groupPlanId : element.groupPlanId,
                    groupId : element.groupId,
                    date : this.lang == 'es' ? element.strDateMonthReport : element.strDateMonthReport_EN,
                    month : element.month,
                    year : element.year,
                    flagTeacherReport : element.flagTeacherReport,
                    flagSearch : element.id > 0 ? true : false,
                    coursesId : element.strGroupRegisterSubjectIds ? element.strGroupRegisterSubjectIds.split('|') : [],
                    courses : element.subjectName ? element.subjectName.split('|') : [],
                    author : element.teacherName,
                    report : element.id == 0 ? true : false,
                }))
                this.totalRows = response.data.rows;
                this.isBusy = false;
            });
        },
    }
}
</script>
<style>
/* Show only the first selected tag as a plain count label, hide the rest */
.courses-vselect .vs__selected ~ .vs__selected {
    display: none;
}
.courses-vselect .vs__selected {
    background: transparent;
    border: none;
    padding: 0 0 0 2px;
    margin: 0;
    color: #333;
    font-size: 15px;
    white-space: nowrap;
}
.courses-vselect .vs__deselect {
    display: none;
}
/* Match deselect-hover color to normal hover blue */
.courses-vselect .vs__dropdown-option--deselect {
    background: var(--vs-dropdown-option--active-bg, #5897fb);
    color: #fff;
}
</style>
